<template>
    <TestCode></TestCode>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TestCode = defineAsyncComponent(() =>
    import("../../components/ITDepartment/TestCode/TestCode.vue") 
);

export default {
    components: { TestCode, AuthLayout },
};
</script>